
        
    const runtime = require("../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
    
        
            __nunjucks_module_dependencies__.templates["milestone/roadmap.njk"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"milestone-container ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"closed")) {
output += "milestone-closed";
;
}
output += "\" data-milestone-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"id"), env.opts.autoescape);
output += "\">\n    <div class=\"milestone milestone-card\">\n        <div class=\"header trigger-backdrop\" data-url=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"backdrop_url"), env.opts.autoescape);
output += "\">\n            <span class=\"name\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"name"), env.opts.autoescape);
output += "</span>\n            <span class=\"info\">\n                <span class=\"info-item\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 5, colno = 58, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["file-alt",{},"far"]))), env.opts.autoescape);
output += "&nbsp;";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"issues_count"), env.opts.autoescape);
output += "</span>\n                <span class=\"icon indicator\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 6, colno = 63, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["spinner",{"classes": "fa-spin"}]))), env.opts.autoescape);
output += "</span>\n                <span class=\"icon expander\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 7, colno = 62, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "UI")),"fa_image_tag"), "UI[\"fa_image_tag\"]", context, ["chevron-down"]))), env.opts.autoescape);
output += "</span>\n            </span>\n            <div class=\"percent-container\">\n                <span class=\"percent-header\">";
output += runtime.suppressValue((lineno = 10, colno = 82, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "T")),"roadmap")),"percent_complete")),"replace"), "T[\"roadmap\"][\"percent_complete\"][\"replace\"]", context, ["%percentage",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"percent_complete")])), env.opts.autoescape);
output += "</span>\n                <span class=\"percent_unfilled\">\n                    <span class=\"percent_filled\" style=\"width: ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "milestone")),"percent_complete"), env.opts.autoescape);
output += "%;\"></span>\n                </span>\n            </div>\n        </div>\n        <div class=\"issues\"></div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":true,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "milestone/roadmap.njk",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "milestone/roadmap.njk",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["milestone/roadmap.njk"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    